import { render, staticRenderFns } from "./Sampling.vue?vue&type=template&id=5be60c20&scoped=true&"
import script from "./Sampling.vue?vue&type=script&lang=js&"
export * from "./Sampling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be60c20",
  null
  
)

export default component.exports